module.exports.matchName = function matchName(stage_name) {
  switch (stage_name) {
    case 'Round of 16':
      return 'Achtelfinale'
    case 'Quarter-finals':
      return 'Viertelfinale'
    case 'Semi-finals':
      return 'Halbfinale'
    case 'Play-off for third place':
      return 'Spiel um den 3. Platz'
    case 'Final':
      return 'Finale'
    default:
      break
  }
}


// WEBPACK FOOTER //
// ./src/components/helpers/matchnames.js